import { FC } from "react"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"

type StyleProps = Readonly<{
    top?: string
    right?: string
}>

type AvailableFromTagProps = StyleProps & {
    date?: string
}

const useStyles = makeStyles<StyleProps>()((theme, { top, right }) => ({
    container: {
        ...(top || right ? { position: "absolute" as const, top, right } : {}),
    },
    tag: {
        padding: `0 0.375rem`,
        fontSize: "0.75rem",
        color: theme.palette.common.black,
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.common.black}`,
        borderRadius: "0.25rem",
        whiteSpace: "nowrap",
    },
}))

export const AvailableFromTag: FC<AvailableFromTagProps> = ({ date, top, right }) => {
    const { classes } = useStyles({ top, right })
    const dateTimeFactory = useDateTime()

    if (!date) return null

    const formattedDate = dateTimeFactory.formatCustom(dateTimeFactory.fromApi(date), "d/M")

    return (
        <Box className={classes.container}>
            <Box className={classes.tag}>
                <LocalizedStrict id="offer-tag-available-from" vars={{ date: formattedDate }}>
                    <Typography variant="caption">Available from: {formattedDate}</Typography>
                </LocalizedStrict>
            </Box>
        </Box>
    )
}

